import type { StateCreator } from 'zustand';

export interface ServicesSlice {
	// Current service ID (can change dynamically via service field)
	currentServiceId: number;

	// Actions
	setCurrentServiceId: (serviceId: number) => void;
}

export const createServicesSlice: StateCreator<ServicesSlice> = (set) => ({
	currentServiceId: 0,

	setCurrentServiceId: (serviceId) => set({ currentServiceId: serviceId }),
});
